export default __webpack_public_path__ + "ad85f3c16c595d449eca6ed011ceca02.svg";